import React from "react";
import PreLoader from "../../_components/PreLoader";
import MainMenu from "../../_components/MainMenu";
import MainFooter from "../../_components/MainFooter";
import { menuService } from "../../_services/menu.service";
import { branchService } from "../../_services/branch.service";
import { userService } from "../../_services/user.service";
import Cities from "./Cities.json";
// import provinces from "./provinces";

// const uniq = (arr = [], prop = "") =>
//   arr.reduce(
//     (acc, value) =>
//       acc.some((v) => v[prop] === value[prop]) ? acc : acc.concat(value),
//     []
//   );

// const compare =
//   (key, order = "asc") =>
//   (a, b) => {
//     if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) return 0;
//     const comparison = a[key].localeCompare(b[key]);

//     return order === "desc" ? comparison * -1 : comparison;
//   };

const UserProfileContext = React.createContext();

const initialState = {
  loading: true,
  user: {},
  menu: {},
  topbarMenu: {},
  branches: {},
  alert: {
    success: null,
    error: null,
  },
  countries: [],
  selectedCountry: "",
  selectedState: [],
  selectedtBarangay:[],
  cities: []
};

const reducer = (state, action) => {
  switch (action.type) {
    case "USER":
      return {
        ...state,
        user: {
          ...state.user,
          ...action.payload,
        },
      };

    case "SET_POSTAL": {
      return {
        ...state,
        user: {
          ...state.user,
          postal: action.payload.postal,
        },
      };
    }

    case "ALERT":
      return {
        ...state,
        alert: action.payload, // Replace the alert payload completely
      };

    case "REINITIALIZE":
      return {
        ...state,
        ...action.payload,
        loading: false,
      };

    case "SET_SELECTED_COUNTRY":
      return {
        ...state,
        selectedCountry: action.payload,
        selectedState: [],
      };

    case "SET_SELECTED_STATE":
      return {
        ...state,
        selectedState: action.payload,
      };

    default:
      return state;
  }
};

const InputField = ({ label, name, placeholder }) => {
    const [user, dispatch] = React.useContext(UserProfileContext);
  
    let value;
    if (name === "first_name") {
      value = user.first_name || "";
    } else if (name === "last_name") {
      value = user.last_name || "";
    } else if (name === "email") {
        value = user.email || "";
    }else{
      const billing = user.billing || {};
      value = billing[name] || "";
    }
  
    const handleChange = (e) => {
      const updatedValue = e.target.value;
      let payload;
  
      if (name === "first_name" || name === "last_name" || name === "email") {
        payload = { [name]: updatedValue };
      } else {
        payload = { billing: { ...user.billing, [name]: updatedValue } };
      }
  
      dispatch({
        type: "USER",
        payload: {
          ...user,
          ...payload,
        },
      });
    };
  
    return (
      <div className="form-group row">
        <label htmlFor={name} className="col-sm-2 col-form-label">
          {label}
        </label>
        <div className="col-sm-10">
          <input
            type="text"
            className="form-control"
            value={value}
            onChange={handleChange}
            placeholder={label || placeholder}
          />
        </div>
      </div>
    );
  };
  
  

  const SelectField = ({ label, name, placeholder, children, selectedCity }) => {
    const [user, dispatch] = React.useContext(UserProfileContext);
  
    const billing = user.billing || {};
    const value = billing[name] || "";
  
    const handleChange = React.useCallback(
      (e) => {
        const newValue = e.target.value;
        let payload = { billing: { ...billing, [name]: newValue } };

        if (name === "city") {
          // Extract postal code based on the selected city
          const postalCode = selectedCity[newValue] || "";
          payload.billing.postcode = postalCode.ZipCode;

        }
  
        dispatch({
          type: "USER",
          payload,
        });
      },
      [billing, name, dispatch, selectedCity]
    );
  
    return (
      <div className="form-group row">
        <label htmlFor={name} className="col-sm-2 col-form-label">
          {label}
        </label>
        <div className="col-sm-10">
          <select
            className="form-control"
            value={value}
            onChange={handleChange}
            placeholder={label || placeholder}
          >
            {children}
          </select>
        </div>
      </div>
    );
  };

const UserProfileEdit = (props) => {
  const [state, dispatch] = React.useReducer(reducer, initialState);
  const [selectedState, setSelectedState] = React.useState([]);
  const [selectedCity, setSelectedCity] = React.useState([]);
  const [barangays, setBarangays] = React.useState([]);
//   const [postalCode, setPostalCode] = React.useState('');
  const [cityNames, setCityNames] = React.useState([]);

    React.useEffect(() => {
        if (state.alert && state.alert.success) {
        const timer = setTimeout(() => {
            dispatch({ type: 'ALERT', payload: { success: null, error: null } });
        }, 5000);
        return () => clearTimeout(timer); // Clear timeout if the component unmounts
        }
    }, [state.alert]);

  const handleSubmit = (e) => {
    e.preventDefault();
  
    const _user = getUser();
    const { billing, shipping, ...restUserData } = state.user; // Extract billing and shipping objects
  
    const updatedData = {
      ...restUserData, // Include other user data (e.g., email, role, etc.)
      billing: {
        ...billing, // Include updated billing data
        address_1: state.user.billing.address_1,
        address_2: state.user.billing.address_2,
        city: state.user.billing.city,
        company: state.user.billing.company,
        country: state.user.billing.country,
        email:  state.user.email,
        first_name: state.user.first_name,
        last_name: state.user.last_name,
        phone: state.user.billing.phone,
        postcode: state.user.billing.postcode,
        state: state.user.billing.state,
        barangay: state.user.billing.barangay
      },
      shipping: {
        ...shipping, // Include updated shipping data
        address_1: state.user.billing.address_1,
        address_2: state.user.billing.address_2,
        city: state.user.billing.city,
        company: state.user.billing.company,
        country: state.user.billing.country,
        first_name: state.user.first_name,
        last_name: state.user.last_name,
        phone: state.user.billing.phone,
        postcode: state.user.billing.postcode,
        state: state.user.billing.state,
      },
      first_name: state.user.first_name,
      last_name: state.user.last_name,
    };

  
    userService.updateCustomer(_user.id, updatedData)
      .then(data => {
        //console.log('Updated customer details:', data);
        // Check if barangay is included in the response
        //console.log('Barangay:', data.billing.barangay);

        dispatch({
          type: 'ALERT',
          payload: { success: 'Successfully updated.', error: null },
        });

         // Extract only relevant fields for local storage
         const updatedLocalStorageData = {
            id: data.id,
            first_name: data.first_name,
            last_name: data.last_name,
            role: data.role,
            user_email: data.email,
            user_login: data.username
          };
  
          // Update user data in local storage
          localStorage.setItem('user', JSON.stringify(updatedLocalStorageData));

          // Scroll to the top of the page
          window.scrollTo({ top: 0, behavior: 'smooth' });
      })
      .catch(error => {
        console.error('Failed to update user details:', error);

        dispatch({
          type: 'ALERT',
          payload: { success: null, error: 'Failed to update user details.' },
        });
      });

    userService
      .update({
        id: _user.id,
        email: state.user.email,
        phone: state.user.phone,
        first_name: state.user.first_name,
        last_name: state.user.last_name,
        address1: state.user.address1,
        address2: state.user.address2,
        region: state.user.region,
        province: state.user.province,
        city: state.user.city,
        barangay: state.user.barangay,
        state: state.user.state,
        country: state.user.country,
        postal: state.user.postal,
      })
      .then((user) => {
        localStorage.setItem(
          "user",
          JSON.stringify({
            ..._user,
            details: {
              ..._user.details,
              ...user,
            },
          })
        );
        // Scroll to the top of the page
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });

    fetch('/wp-json/custom/v1/update-customer/', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            user_id: _user.id,
            barangay: state.user.billing.barangay,
        }),
    })
    .then(response => response.json())
    .then(data => console.log('Custom API response:', data))
    .catch(error => console.error('Custom API error:', error));
  };

  const getUser = () => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      return user;
    } catch (err) {
      return null;
    }
  };

  // const barangays = provinces
  //   .filter(
  //     (v) =>
  //       v.Province === state.user.province && v.Location === state.user.city
  //   )
  //   .sort(compare("barangay"));

  //   React.useEffect(() => {
  //       dispatch({
  //       type: "SET_POSTAL",
  //       payload: {
  //           postal:
  //           provinces.filter(
  //               (v) =>
  //               v.Province === state.user.province &&
  //               v.Location === state.user.city
  //           )?.[0]?.["ZIP Code"],
  //       },
  //       });
  //   }, [state.user.province, state.user.city]);

    React.useEffect(() => {
        const promises = [
          menuService.getMenuByName('default').then((menu) => ({ menu })),
          menuService.getMenuByName("Topbar").then((topbarMenu) => ({ topbarMenu })),
          branchService.getAll({ page: 1, items: 5, filter: { homepage: true } }).then((branches) => ({ branches })),
          userService.getCountries().then((countryData) => ( { countries: countryData })),
        ];
      
        const user = getUser();
      
        if (user) {
          promises.push(userService.getCustomers(user.id).then((user) => ({ user })));
        }
      
        Promise.allSettled(promises).then((results) => {
          const newState = results
            .filter((v) => v.status === "fulfilled")
            .reduce((acc, item) => {
              const [[key, value]] = Object.entries(item.value);
              return { ...acc, [key]: value };
            }, {});
      
          dispatch({ type: "REINITIALIZE", payload: { ...newState } });
        });
      }, []);
      
      React.useEffect(() => {
        if (state.user.billing?.country) {
            // console.log(state.user.billing?.country)
            // console.log(state.countries)
          const countryData = state.countries.find(c => c.code === state.user.billing.country);
          setSelectedState(countryData?.states || []);
        }
      }, [state]);

      React.useEffect(() => {
        if (state.user.billing?.state) {
            const citiesList = Cities[state.user.billing.state] || {};
            setSelectedCity(citiesList);
            setCityNames(Object.keys(citiesList));
        }
    }, [state.user.billing]);
	  // Fetch barangays based on city selection
	  React.useEffect(() => {
		if (state.user.billing?.city) {
		  const cityData = selectedCity[state.user.billing.city] || {};
		  
		  const barangayList = cityData.Barangays || [];
		  
		  setBarangays(barangayList);
		}
	  }, [state.user.billing, selectedCity]);

      
      const handleCountryChange = (e) => {
        const country = e.target.value;
        const countryData = state.countries.find(c => c.code === country);
        setSelectedState(countryData?.states || []);
      };

    //   const handleCityChange = (e) => {
    //     const selectedCityName = e.target.value;
    //     console.log('Selected City:', selectedCityName);

    //     const postalCode = selectedCity[selectedCityName] || '';
    //     console.log('Postal Code:', postalCode);

    //     dispatch({
    //         type: "USER",
    //         payload: {
    //             billing: {
    //                 ...state.user.billing,
    //                 city: selectedCityName,
    //                 postcode: postalCode
    //             }
    //         }
    //     });
    // };
      
      //const cityNames = Object.keys(selectedCity || {});
    //   console.log(cityNames)
    //   console.log(selectedCity)
    //   console.log(postalCode)
    //   console.log(state.user)
	//   console.log(barangays)

  return (
    <UserProfileContext.Provider value={[state.user, dispatch]}>
      <PreLoader loading={state.loading} />
      <MainMenu
        user={state.user}
        menu={state.menu}
        topbarMenu={state.topbarMenu}
      />
      <section className="main-content">
        <div className="container p-5">
          <div className="row">
            <div className="col">
              {state.alert.success ? (
                <div className="alert alert-success" role="alert">
                  {state.alert.success}
                </div>
              ) : state.alert.error ? (
                <div className="alert alert-danger" role="alert">
                  {state.alert.error}
                </div>
              ) : null}
              <form onSubmit={handleSubmit}>
                <h4>Personal Information</h4>
                <InputField label="First Name" name="first_name" />
                <InputField label="Last Name" name="last_name" />
                <InputField label="Email Address" name="email" />
                <InputField label="Phone" name="phone" />
                <h4 className="mt-4">Billing Address</h4>
                <InputField label="Address Line 1" name="address_1" />
                <InputField label="Address Line 2" name="address_2" />

                <SelectField
                    label="Country"
                    name="country"
                    value={state.user.billing?.country || ""}
                    onChange={(e) => {
                        handleCountryChange(e);
                        dispatch({ type: "USER", payload: { billing: { country: e.target.value } } });
                    }}
                >
                    <option value="" disabled>Choose...</option>
                    {state.countries?.map((country) => (
                        <option key={country.code} value={country.code}>
                            {country.name}
                        </option>
                    ))}
                </SelectField>

                <SelectField
                    label="State"
                    name="state"
                    value={state.user.billing?.state || ""}
                    onChange={(e) => {
                        dispatch({ type: "USER", payload: { billing: { state: e.target.value } } });
                    }}
                >
                    <option value="" disabled>Choose...</option>
                    {selectedState?.map((state) => (
                        <option key={state.code} value={state.code}>
                            {state.name}
                        </option>
                    ))}
                </SelectField>

                <SelectField
                    label="City"
                    name="city"
                    selectedCity={selectedCity}
                    //onChange={handleCityChange}
                >
                    <option value="" disabled>Choose...</option>
                    {cityNames?.map((city) => (
                        <option key={city} value={city}>
                            {city}
                        </option>
                    ))}
                </SelectField>

				<SelectField
                    label="Barangay"
                    name="barangay"
                    value={state.user.billing?.barangay || ""}
                    onChange={(e) => {
                        dispatch({
                            type: "USER",
                            payload: {
                                billing: {
                                    ...state.user.billing,
                                    barangay: e.target.value
                                }
                            }
                        });
                    }}
                >
                    <option value="" disabled>Choose...</option>
                    {barangays?.map((barangay) => (
                        <option key={barangay} value={barangay}>
                            {barangay}
                        </option>
                    ))}
                </SelectField>

                {/* <InputField
                    label="Barangay"
                    name="barangay"
                    value={state.user.billing?.barangay || ""}
                    onChange={(e) => {
                        dispatch({
                            type: "USER",
                            payload: {
                                billing: {
                                    ...state.user.billing,
                                    barangay: e.target.value
                                }
                            }
                        });
                    }}
                /> */}

                {
                    state.user.billing?.city !== "" ?
                    <InputField
                        label="Postcode / ZIP"
                        name="postcode"
                        value={state.user.billing?.postcode || ""}
                        onChange={(e) => {
                            dispatch({
                                type: "USER",
                                payload: {
                                    billing: {
                                        ...state.user.billing,
                                        postcode: e.target.value
                                    }
                                }
                            });
                        }}
                    />   
                    :
                    ""
                }


                {/* <SelectField label="City" name="city">
                  <option value="" disabled>
                    Choose...
                  </option>
                  {uniq(
                    provinces.filter((v) => v.Province === state.user.province),
                    "Location"
                  )
                    .sort(compare("Location"))
                    .map((province) => (
                      <option
                        value={province.Location}
                        key={`${province.Location}${province.id}`}
                      >
                        {province.Location}
                      </option>
                    ))}
                </SelectField>
                {barangays.filter((barangay) => barangay.barangay).length ? (
                  <SelectField label="Barangay" name="barangay">
                    <option value="" disabled>
                      Choose...
                    </option>
                    {barangays.map((province) => (
                      <option
                        value={province.barangay}
                        key={`${province.barangay}${province.id}`}
                      >
                        {province.barangay}
                      </option>
                    ))}
                  </SelectField>
                ) : (
                  <InputField label="Barangay" name="barangay" />
                )}
                {provinces.filter((v) => v.Province === state.user.province && v.Location === state.user.city)?.[0]?.["ZIP Code"] ? <InputField label="Zip code" name="postal" /> : null} */}
                <button
                  type="submit"
                  className="btn btn-warning"
                  style={{ color: "#fff" }}
                >
                  Update
                </button>
                <button
                  className="btn btn-danger ml-3"
                  onClick={() => props.history.push("/")}
                >
                  Cancel
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
      <MainFooter menu={state.menu} branches={state.branches} />
    </UserProfileContext.Provider>
  );
};

export { UserProfileEdit };
